module.exports = __webpack_public_path__ + "static/media/RADIYA BADENJKI.17041483.png";